var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcTrophyWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_206_5212)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.91659 1.16663H4.08325V4.08329C4.08325 5.05552 4.66659 6.99996 6.99992 6.99996C9.33325 6.99996 9.91659 5.05552 9.91659 4.08329V1.16663Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.91659 2.33325H11.2499C11.8022 2.33325 12.2499 2.78097 12.2499 3.33325V4.08325C12.2499 4.76381 12.2499 5.83325 9.33325 5.83325",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.08341 2.33325H2.75008C2.1978 2.33325 1.75008 2.78097 1.75008 3.33325V4.08325C1.75008 4.76381 1.75008 5.83325 4.66675 5.83325",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 7V9.91667",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_206_5212",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.08325 10.9166C4.08325 10.3643 4.53097 9.91663 5.08325 9.91663H8.91658C9.46887 9.91663 9.91659 10.3643 9.91659 10.9166V13.4166H4.08325V10.9166Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.08325 10.9166C4.08325 10.3643 4.53097 9.91663 5.08325 9.91663H8.91658C9.46887 9.91663 9.91659 10.3643 9.91659 10.9166V13.4166H4.08325V10.9166Z",
    stroke: "white",
    strokeWidth: 3.5,
    mask: "url(#path-5-inside-1_206_5212)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_206_5212"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTrophyWhite);
export default __webpack_public_path__ + "static/media/ic_trophy_white.f612b3cdcb0565da9dc03ca7153348ef.svg";
export { ForwardRef as ReactComponent };